export enum ErrorType {
  EntityNotFound = 'EntityNotFound',
  AccountAlreadyExists = 'AccountAlreadyExists',
  ApplicationWithdrawNotPossible = 'ApplicationWithdrawNotPossible',
  ApplicationAlreadyAccepted = 'ApplicationAlreadyAccepted',
  ApplicationAlreadyRejected = 'ApplicationAlreadyRejected',
  OrderStateIllegal = 'OrderStateIllegal',
  OrderVideoAlreadyUploaded = 'OrderVideoAlreadyUploaded',
  OrderImageAlreadyUploaded = 'OrderImageAlreadyUploaded',
  OrderAlreadyAccepted = 'OrderAlreadyAccepted',
  OrderVideoRetrievalError = 'OrderVideoRetrievalError',
  OrderNotRefundable = 'OrderNotRefundable',
  ListingNotRefundable = 'ListingNotRefundable',
}
